<template>
  <v-menu
    ref="datePickerMenu"
    v-model="datePickerMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="value"
        v-on="on"
        :label="label"
        dense
        readonly
        v-bind="attrs"
        :prefix="prefix"
        outlined
        :rounded="rounded"
        :filled="filled"
        append-icon="mdi-calendar-month-outline"
      />
    </template>
    <v-date-picker
      color="primary"
      no-title
      :value="value"
      @input="handleInput($event)"
      :min="todaysDate"
      @change="handleInput"
    >
      <v-spacer></v-spacer>
      <v-btn text color="grey--lighten-3" @click="datePickerMenu = false">
        CANCEL
      </v-btn>
      <v-btn text color="primary" @click="$refs.datePickerMenu.save($event)">
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    prefix: { type: String },
    label: { type: String },
    rounded: { type: Boolean, default: false },
    filled: { type: Boolean, default: false },
  },
  data() {
    return {
      datePicker: null,
      date: null,
      datePickerMenu: false,
      todaysDate: new Date().toISOString().slice(0, 10),
    };
  },
  methods: {
    handleInput(event) {
      this.datePickerMenu = false;
      this.$emit("input", event);
    },
  },
};
</script>
